var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCampaigns = function SvgCampaigns(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 10.0833V11.9167H20.1666V10.0833H16.4999ZM14.6666 16.1425C15.5466 16.7933 16.6924 17.655 17.5999 18.3333C17.9666 17.8475 18.3333 17.3525 18.6999 16.8667C17.7924 16.1883 16.6466 15.3267 15.7666 14.6667C15.3999 15.1617 15.0333 15.6567 14.6666 16.1425ZM18.6999 5.13332C18.3333 4.64749 17.9666 4.15249 17.5999 3.66666C16.6924 4.34499 15.5466 5.20666 14.6666 5.86666C15.0333 6.35249 15.3999 6.84749 15.7666 7.33332C16.6466 6.67332 17.7924 5.82082 18.6999 5.13332ZM3.66659 8.24999C2.65825 8.24999 1.83325 9.07499 1.83325 10.0833V11.9167C1.83325 12.925 2.65825 13.75 3.66659 13.75H4.58325V17.4167H6.41659V13.75H7.33325L11.9166 16.5V5.49999L7.33325 8.24999H3.66659ZM14.2083 11C14.2083 9.78082 13.6766 8.68082 12.8333 7.92916V14.0617C13.6766 13.3192 14.2083 12.2192 14.2083 11Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCampaigns, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/campaigns.6fa84251.svg";
export { ForwardRef as ReactComponent };